<template>
    <div class="highlight-bar">
        <div class="highlight-bar__container">
            <high-light></high-light>
        </div>
    </div>
</template>

<script>
import HighLight from './HighLight.vue';

export default {
    components: {
        HighLight
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        }
    }
}
</script>

<style lang="scss">
.highlight-bar {
    background-color: #f5f5f5;
    padding: 10px 0;
    flex: 1;

    .highlight-bar__container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
</style>
